<script setup>
import { provide, ref } from 'vue';

const openTabs = ref({});
const closeOthers = ref(true);

provide('accordion', { openTabs, closeOthers });
</script>

<template>
  <div class="accordion-heading-full product-attributes">
    <div class="panel-group">
      <slot></slot>
    </div>
  </div>
</template>
